import { useEffect, useRef } from 'react';

/** Interval ticker that pauses while the tab is hidden and fires a catch-up tick
 *  when it becomes visible again. Manual and auto refresh share the same onTick. */
export function useRefreshLoop({
  intervalMs,
  onTick,
  enabled = true,
}: {
  intervalMs: number;
  onTick: () => void;
  enabled?: boolean;
}) {
  const cb = useRef(onTick);
  cb.current = onTick;

  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => {
      if (!document.hidden) cb.current();
    }, intervalMs);
    const onVisible = () => {
      if (!document.hidden) cb.current(); // catch up on return
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs, enabled]);
}
